export default __webpack_public_path__ + "static/media/frenzy.7cdc0378.png";